import axios from "axios";

// Load environment variables
const baseURL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000"; // Fallback if env is missing
console.log("✅ Base URL:", baseURL);

// Retrieve the token from localStorage
const token = localStorage.getItem("authToken");
console.log("✅ Auth Token:", token || "No Token Found");

// Create an Axios instance
const axiosMain = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    Authorization: token ? `Bearer ${token}` : "",
  },
  withCredentials: true, // Allow cookies in requests
});

// ✅ Add an interceptor to handle errors globally
axiosMain.interceptors.response.use(
  (response) => response, // Return response if successful
  (error) => {
    if (!error.response) {
    } else {
      console.error(
        "❌ Axios Error:",
        error.response.status,
        error.response.data
      );
    }
    return Promise.reject(error);
  }
);

export default axiosMain;
